export default __webpack_public_path__ + "static/media/Pietro Spirito.041f3472.jpg";